<script>
import { mapActions } from 'vuex'
import { list, get, del } from '@/api/prazo'

// Colunas
import columns from './colunas'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  async mounted () {
    this.modalAdd = await this.newModal({
      component: 'app-prazo-edit',
      width: 300,
      onSave: async (data) => {
        if (data.grupo) this.refresh(data.grupo)
        else this.$refs.completeGrid.refreshList()
      },
      onCancel: () => {
        this.$refs.completeGrid.focoPesquisa()
      }
    })
  },
  data () {
    return {
      tela: 'prazo',
      acoes: {
        add: 'prazo_incluir',
        edit: 'prazo_editar',
        delete: 'prazo_excluir'
      },
      modalAdd: false,
      columns: columns,
      indices: [
        // 'prazo_descricao', 'prazo_formula', 'qtde_parc_prazo'
        { value: 'prazo_descricao', label: 'Descrição' },
        { value: 'prazo_formula', label: 'Fórmula' },
        { value: 'qtde_parc_prazo', label: 'Qtde Parcelas' }
      ]
    }
  },
  methods: {
    ...mapActions({
      newModal: 'modal/new',
      openModal: 'modal/open',
      confirmarModal: 'modal/confirmar',
      toaster: 'modal/toaster'
    }),
    refresh (data) {
      if (this.mode === 'tab') this.$refs.completeGrid.refreshList()
      else if (this.mode === 'modal') this.$refs.completeGrid.changeBusca(data)
    },
    async getList (filtros) {
      let data = await list(filtros)
      return {
        data: data.data,
        totalCount: data.total
      }
    },
    async novo () {
      let data = {
        prazo_descricao: null,
        prazo_formula: null,
        qtde_parc_prazo: null,
        privilegio_por_cadastro: 'N',
        sincronizado: 'S'
      }
      this.openModal({ modal: this.modalAdd, data })
    },
    async editar (row) {
      let data = await get(row.data.id)
      this.openModal({ modal: this.modalAdd, data })
    },
    async excluir (row) {
      this.confirmarModal({
        msg: 'Deseja realmente excluir esse grupo?',
        onConfirm: async () => {
          await del(row.data.id)
          this.toaster({ message: 'Excluido com sucesso!', color: 'success' })
          this.$refs.completeGrid.refreshList()
        }
      })
    },
    async selecionar (selecionado) {
      if (selecionado.id) this.$emit('save', selecionado)
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Listar Prazo" @onClose="() => $emit('cancel')">
    <ui-complete-grid
      ref="completeGrid"
      :tela="tela"
      :columns="columns"
      :indices="indices"
      :selection="mode === 'modal'"
      :datasource="getList"
      :acoes="acoes"
      @onSelect="selecionar"
      @onCancel="$emit('cancel')"
      @onAdd="novo"
      @onEdit="editar"
      @onDelete="excluir" />
  </ui-layout-modal>
</template>
